import gql from 'graphql-tag';

export const bulkUpdateTaskStatusMutation = gql`
  mutation bulkUpdateTaskStatus(
    $taskIds: [String!]!
    $status: String!
  ) {
    bulkUpdateTaskStatus(
      taskIds: $taskIds
      status: $status
    ) {
      successCount
      failureCount
      failures {
        taskId
        reason
      }
    }
  }
`;

